module.exports = __webpack_public_path__ + "static/media/u50_premium_contract3.2580e7ab.webp";